(function(){
    if(window.sticky_cart_installed){
        return;
    }

    window.sticky_cart_installed = true;

    var config = {"padding": "10", "automatic": true, "background": "#0084ff", "foreground": "#ffffff", "custom_html": "", "advanced": false, "location": "bottom", "animation": "none", "size": "24", "display": "all", "custom_click_handler": "", "custom_selector": ""};
    var original_button = null;
    var sticky_button = null;
    var animation_interval = -1;

    function is_mobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    function animate(){
        if(config.animation != 'none'){
            sticky_button.classList.remove('animated');
            sticky_button.classList.remove(config.animation);

            setTimeout(function(){
            sticky_button.classList.add('animated');
            sticky_button.classList.add(config.animation);
            },10);
        }
    }

    function scroll(e){
        if(!find_button()){
            return;
        }

        var original_rect = original_button.getBoundingClientRect();
        var sticky_rect = sticky_button.getBoundingClientRect();
        var location = -10 * sticky_rect.height;

        if(original_rect.top < 0){
            location =  (-1 * sticky_rect.height) - original_rect.top;
            if(location > 0){
                location = 0;
                if(animation_interval == -1){
                    animation_interval = setInterval(animate, 5000);
                }
            }else{
                clearInterval(animation_interval);
                animation_interval = -1;
            }
        }else{
            clearInterval(animation_interval);
            animation_interval = -1;
        }

        sticky_button.style[config.location] = location + 'px';
    }

    function find_button(){
        var selectors = [
            'form[action="/cart/add"] [type="submit"]',
            'form button.add-to-cart',
            '.addtocart-js',
            '#AddToCart'
        ];

        if(config.advanced && config.custom_selector != ''){
            selectors = [config.custom_selector];
        }

        for(var i = 0; i < selectors.length; i++){
            var buttons = document.querySelectorAll(selectors[i]);

            for(var j = 0; j < buttons.length; j++) {
                var button = buttons[j];
                if (button) {
                    var button_rect = button.getBoundingClientRect();
                    if (button_rect.width > 0 && button_rect.height > 0) {
                        original_button = button;
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function click(){
        if(config.advanced && config.custom_click_handler != '') {
            eval(config.custom_click_handler);
        }else {
            original_button.click();
        }
    }

    function initialize(){
        if (config.display == 'mobile' && !is_mobile()) {
            return;
        }
        if (config.display == 'desktop' && is_mobile()) {
            return;
        }
        if(!find_button()){
            return;
        }

        var style = getComputedStyle(original_button);

        sticky_button = document.createElement('button');

        sticky_button.style.font = style.font;
        sticky_button.innerText = original_button.innerText;
        sticky_button.classList.add('sticky-cart-button');

        if(original_button.tagName === 'INPUT'){
            sticky_button.innerText = original_button.value;
        }

        if(config.advanced && config.custom_html != ''){
            sticky_button.innerHTML = config.custom_html;

        }

        if(config.automatic){
            sticky_button.style.background = style.background;
            sticky_button.style.color = style.color;
            sticky_button.style.padding = style.padding;
            sticky_button.style.border = style.border;
            sticky_button.style.borderRadius = style.borderRadius;
        }else {
            sticky_button.style.border = 'initial';
            sticky_button.style.borderRadius = 'initial';
            sticky_button.style.background = config.background;
            sticky_button.style.color = config.foreground;
            sticky_button.style.fontSize = config.size + 'px';
            sticky_button.style.padding = config.padding + 'px';
        }

        sticky_button.style.position = 'fixed';
        sticky_button.style.bottom = -100000000;
        sticky_button.style.zIndex = 999;
        sticky_button.style.left = 0;
        sticky_button.style.right = 0;
        sticky_button.style.textAlign = 'center';
        sticky_button.style.display = 'block';
        sticky_button.style.width = '100%';

        sticky_button.addEventListener('click', click);

        document.body.appendChild(sticky_button);

        var sticky_rect = sticky_button.getBoundingClientRect();
        document.body.style.paddingBottom = sticky_rect.height + 'px';

        document.addEventListener('scroll', scroll);
        scroll();
    }

    initialize();
})();

